export default function registerVolumeErrorForMissingTurboFrame (frameId) {
  if (window.Carwow && window.Carwow.registerBugsnagVolumeError) {
    window.Carwow.registerBugsnagVolumeError((error) => {
      // TurboFrameMissing error classes are set inside bugsnag_module.js's `setTurboFrameContext` function
      const turboFrameError = error.errorClass.includes('TurboFrameMissingError')
      const forCorrectFrame = error.errorClass.includes(frameId)

      return turboFrameError && forCorrectFrame
    })
  }
}
